// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3EfE4","cell":"ColumnAccessor_cell__1wNfD","firstCellAccent":"ColumnAccessor_firstCellAccent__1fQ8p"};